import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import TopBar from './components/TopBar';
import Hero from './components/Hero';
import LanguageSecretSection from './components/LanguageSecretSection';
import SolutionSection from './components/SolutionSection';
import FeaturesDetailSection from './components/FeaturesDetailSection';
import LearningFeaturesSection from './components/LearningFeaturesSection';
import IPadSection from './components/IPadSection';
import EverywhereSection from './components/EverywhereSection';
import MimickingSection from './components/MimickingSection';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AccountDeletion from './components/AccountDeletion';

function HomePage() {
  return (
    <>
      <TopBar />
      <Hero />
      <LanguageSecretSection />
      <SolutionSection />
      <FeaturesDetailSection />
      <LearningFeaturesSection />
      <EverywhereSection />
      <IPadSection />
      <MimickingSection />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

